// extracted by mini-css-extract-plugin
module.exports = {"subHead":"SubHeader_subHead__pkmog","title":"SubHeader_title__q3SYD","subTitle":"SubHeader_subTitle__Sho2w","link":"SubHeader_link__ufnT_"};